'use client'

import { createContext, use, ReactNode } from 'react'

import { usePathname } from 'next/navigation'

interface ExperimentalStylingContextType {
  enableExperimentalStyling: boolean
}

export const ExperimentalStylingContext = createContext<
  ExperimentalStylingContextType | undefined
>(undefined)

// Routes that should use new styling
const NEW_STYLING_ROUTES = [
  '/schedules',
  '/invoices',
  '/component-library/address-display',
  '/multisend',
  '/send',
  '/swap',
  '/automations',
  // Add more routes here as you migrate them
]

export const ExperimentalStylingProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const pathname = usePathname()

  // Determine if we should use new styling based on the current route
  const enableExperimentalStyling =
    NEW_STYLING_ROUTES.some((route) => pathname?.startsWith(route)) ?? false

  return (
    <ExperimentalStylingContext value={{ enableExperimentalStyling }}>
      {children}
    </ExperimentalStylingContext>
  )
}

export const useExperimentalStyling = () => {
  const context = use(ExperimentalStylingContext)
  if (context === undefined) {
    // Default to old styling if context is not provided
    return { enableExperimentalStyling: false }
  }
  return context
}
